export const statusProcedure = (status) => {
    switch (status) {
        case 1:
            return "Submmited";
        case 2:
            return "Approved";
        case 3:
            return "Commented";
        case 4:
            return "Superseded";
        case 5:
            return "Reviewed";
        case 6:
            return "Rejected";
    }
}

const MATERIAL_LOT_STATUS = {
    AVAILABLE: "AVAILABLE",
    PARTIALLY_USED: "PARTIALLY_USED",
    FULLY_USED: "FULLY_USED",
    SCRAPPED: "SCRAPPED",
};

const MATERIAL_PIECE_STATUS = {
    PENDING: "PENDING",
    AVAILABLE: "AVAILABLE",
    ISSUED: "ISSUED",
    RECUT: "RECUT",
    SCRAPPED: "SCRAPPED",
    CANCELLED: "CANCELLED",
    RETURNED: "RETURNED",
};

const MATERIAL_WASTAGE_TYPE = {
    CUT_LOSS: "CUT_LOSS",
    REMNANT_SCRAP: "REMNANT_SCRAP",
    DAMAGED: "DAMAGED",
    PROCESS_LOSS: "PROCESS_LOSS",
};

export const lotStatus = (status) => {
    switch (status) {
        case MATERIAL_LOT_STATUS.AVAILABLE:
            return {
                name: "Available",
                class: "custom-badge status-green"
            };
        case MATERIAL_LOT_STATUS.PARTIALLY_USED:
            return {
                name: "Partially Used",
                class: "custom-badge status-orange"
            };
        case MATERIAL_LOT_STATUS.FULLY_USED:
            return {
                name: "Fully Used",
                class: "custom-badge status-yellow"
            };
        case MATERIAL_LOT_STATUS.SCRAPPED:
            return {
                name: "Scrapped",
                class: "custom-badge status-purple"
            };
        default:
            return {
                name: "Unknown",
                class: "custom-badge status-grey"
            };
    }

}